import dayjs from 'dayjs';

const START_YEAR = 1920;
const CURRENT_YEAR = new Date().getFullYear();
const GENDERS = [{ key: '1', label: "男性" }, { key: '2', label: "女性" }, { key: '0', label: "選択なし" } ];
const MONTHS = Array.from({length: 12}, (item, i) => {
  return dayjs(new Date(0, i)).format("MM");
});
const YEARS = Array(CURRENT_YEAR - START_YEAR + 1).fill().map((_, idx) => CURRENT_YEAR - idx);
const YEARS_START_FROM_2022 = Array(CURRENT_YEAR - 2022 + 1).fill().map((_, idx) => CURRENT_YEAR - idx);
const CURRENT_MONTH = dayjs(new Date()).format("MM");
const CURRENT_DAY = dayjs(new Date()).format("DD");
const IMAGE_EXTENSIONS = ['jpeg', 'png', 'jpg'];
const IS_CANCELLED = true;
const TRANSACTION_TYPE = { receipt: '1', charge: '2', present: '3'};
const AGES = 18;

const STATUS_CONTACT = {
  unsolved: 0,
  solved: 1,
  reply_from_user: 2,
  reply_from_admin: 3
};
const CONTACT_TYPES = {
  type_user: 1,
  type_partner: 2,
  type_other: 3
};
const SITE_TYPE = {
  site_admin: 1,
  site_partner: 2
}

const USER_ROLE = {
  admin: 0,
  partner : {
    company: 1,
    shop: 2,
    staff: 3,
  }
}

const LOGIN_TYPE = {
  email: 1,
  line: 2,
}

const PARTNER_STATUS = {
  inactive: 0,
  active: 1,
  pending: 2

}
const HTTP_STATUS = {
  success: 200
}

const MAX_SIZE_IMAGE = 10 //MB

const MAX_SIZE_IMAGE_BYTE = 10485760 //KB

const NOTICE_TYPE = {
  user: 1,
  partner: 2
}

const CONTACT_FROM = {
  admin: 1,
  contacter: 2
}

const TYPE_PROFIT = {
  company: 1,
  shop: 2,
  staff: 3
}

const REGIONS = [
  { id: 1, name: '北海道・東北', value: '1,2' },
  { id: 2, name: '関東', value: '3' },
  { id: 3, name: '中部', value: '4' },
  { id: 4, name: '近畿', value: '5' },
  { id: 5, name: '中国・四国', value: '6,7' },
  { id: 6, name: '九州・沖縄', value: '8,9' }
];

const USER_SITE_DOMAIN = 'https://kokoroduke.regit-technology.com';
const LINE_URL = `${process.env.MIX_PARTNER_SITE_DOMAIN}/line/redirect`;

export {
  START_YEAR,
  CURRENT_YEAR,
  GENDERS,
  MONTHS,
  YEARS,
  CURRENT_MONTH,
  CURRENT_DAY,
  IMAGE_EXTENSIONS,
  IS_CANCELLED,
  TRANSACTION_TYPE,
  STATUS_CONTACT,
  CONTACT_TYPES,
  SITE_TYPE,
  USER_ROLE,
  HTTP_STATUS,
  MAX_SIZE_IMAGE,
  NOTICE_TYPE,
  CONTACT_FROM,
  REGIONS,
  TYPE_PROFIT,
  YEARS_START_FROM_2022,
  PARTNER_STATUS,
  USER_SITE_DOMAIN,
  MAX_SIZE_IMAGE_BYTE,
  AGES,
  LINE_URL,
  LOGIN_TYPE,
};
